
import React, { useRef,useState } from 'react';
import emailjs from '@emailjs/browser';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import './Form.css'
const FormComp = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_om4n70q', 'template_msao0uc', form.current, 'Xwxe0iv_bWfLwZt1G')
    
          .then((result) => {
              
          }, (error) => {
              console.log(error.text);
          });
      };

  const sendEmail1 = (e) => {
      const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      
    }

    setValidated(true);
  
   
  };
  

  const [validated, setValidated] = useState(false);


  return (
      <>

      <Form className='form-container' noValidate validated={validated} ref={form} onSubmit={sendEmail}>
           <Row className="mb-3">
             <Form.Group as={Col} md="6" controlId="validationCustom01">
               <Form.Label className='form-label'>First name</Form.Label>
            <Form.Control
                required
                type="text"
                name="user_name"
                placeholder="Name"
                defaultValue=""
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>
           
            <Form.Group as={Col} md="6" controlId="validationCustomUsername">
              <Form.Label className='form-label'>Email</Form.Label>
              <InputGroup hasValidation>
                <Form.Control
                  type="email"
                  name="user_email"
                  placeholder="Username"
                  aria-describedby="inputGroupPrepend"
                  required
                />
                {/* <Form.Control.Feedback type="invalid">
                  Please choose email.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="12" controlId="validationCustom03">
              <Form.Label className='form-label'>Message</Form.Label>
               <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
        <Form.Control  name="message" placeholder='Message' required as="textarea" rows={8} width="100%" />
      </Form.Group>
            </Form.Group>
        
          </Row>
         
          <Button type="submit" value="Send">Submit form</Button>
        </Form>
    

  </>
  );
};
export default FormComp;

